import React, { useEffect, useState, useRef } from "react";
import "./Card.css";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Card = (props) => {
  // var itemPrice = props.price;
  const nameFocus = useRef();
  const addressFocus = useRef();
  const [itemPrice, setItemPrice] = useState(props.price);
  const [orderPlaced, setOrderPlaced] = useState(false);
  // const [userName, setUserName] = useState(
  //   localStorage.getItem("foodapp-name")
  // );
  // const nameCheck = () => {
  //   if (localStorage.getItem("foodapp-name")) return true;
  // };
  const [name, setName] = useState({
    enteredName: localStorage.getItem("foodapp-name"),
    isValid: true,
  });
  const [address, setAddress] = useState({
    enteredAddress: "",
    isValid: true,
  });
  const cancel = useRef();
  const closeCollapse = useRef();
  const [quantity, setQuantity] = useState(1);

  const cancelHandler = () => {
    setQuantity(1);
    setName((prevState) => {
      return {
        ...prevState,
        enteredName: localStorage.getItem("foodapp-name"),
      };
    });
    setAddress((prevState) => {
      return { ...prevState, enteredAddress: "" };
    });
    setItemPrice((prevState) => {
      return (prevState = props.price);
    });

    // window.location.reload();
    // if (orderPlaced) {
    //   closeCollapse.current.disabled = false;
    //   setOrderPlaced(!orderPlaced);

    //   closeCollapse.current.click();
    // }
  };

  const plusHandler = () => {
    setQuantity((prevState) => {
      return prevState + 1;
    });
    setItemPrice((prevState) => {
      return prevState + props.price;
    });
    // itemPrice = itemPrice + props.price;
    // setPrice((prevState) => {
    //   return prevState + price;
    // });
    // console.log(price);
  };

  const placeOrderHandler = () => {
    setOrderPlaced(!orderPlaced);
  };

  const minusHandler = () => {
    setQuantity((prevState) => {
      return prevState - 1;
    });
    setItemPrice((prevState) => {
      return prevState - props.price;
    });
  };

  const nameChangeHandler = (event) => {
    if (event.target.value === "") {
      setName((prevState) => {
        return { ...prevState, enteredName: event.target.value };
      });
      setName((prevState) => {
        return { ...prevState, isValid: false };
      });
      return;
    }
    setName((prevState) => {
      return { ...prevState, isValid: true };
    });
    setName((prevState) => {
      return { ...prevState, enteredName: event.target.value };
    });
  };

  const addressChangeHandler = (event) => {
    if (event.target.value === "") {
      setAddress((prevState) => {
        return { ...prevState, enteredAddress: event.target.value };
      });
      setAddress((prevState) => {
        return { ...prevState, isValid: false };
      });
      return;
    }

    setAddress((prevState) => {
      return { ...prevState, enteredAddress: event.target.value };
    });
    setAddress((prevState) => {
      return { ...prevState, isValid: true };
    });
  };

  // const nameValidHandler = () => {
  //   if (name.enteredName === "") {
  //     setName((prevState) => {
  //       return { ...prevState, isValid: false };
  //     });
  //   } else {
  //     setName((prevState) => {
  //       return { ...prevState, isValid: true };
  //     });
  //   }
  // };

  const submitHandler = (event) => {
    event.preventDefault();
    if (name.enteredName === "") {
      setName((prevState) => {
        return { ...prevState, isValid: false };
      });

      nameFocus.current.focus();
      return;
    }
    if (address.enteredAddress === "") {
      setAddress((prevState) => {
        return { ...prevState, isValid: false };
      });
      addressFocus.current.focus();
      return;
    }
    const orderData = {
      productname: props.productname,
      quantity: quantity,
      price: itemPrice,
      name: name.enteredName,
      email: localStorage.getItem("foodapp-email"),
      address: address.enteredAddress,
    };
    // console.log(orderData);
    fetch(
      "https://react-foodapp-ec92c-default-rtdb.firebaseio.com/orders.json",
      { method: "POST", body: JSON.stringify(orderData) }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        toast.success("Order Placed Successfully", {
          position: "bottom-center",
        });
      });
    // setName((prevState) => {
    //   return {
    //     ...prevState,
    //     enteredName: localStorage.getItem("foodapp-name"),
    //   };
    // });
    // setAddress((prevState) => {
    //   return { ...prevState, enteredAddress: "" };
    // });
    // setItemPrice((prevState) => {
    //   return (prevState = props.price);
    // });
    // setQuantity(1);
    cancel.current.click();
  };

  return (
    <div className="pad">
      <div className="card">
        <h2 className="card-header">
          <div className="alert alert-warning" role="alert">
            {props.productname}
          </div>
        </h2>
        <div className="card-body">
          <h4 className="card-title">Price: {itemPrice}</h4>
          <p className="card-text">{props.productdescripton}</p>
          <ToastContainer />
          <button
            type="button"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target={`#a${props.productid}`}
          >
            Buy Now
          </button>

          <div
            className="modal fade"
            id={`a${props.productid}`}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h2 className="modal-title" id="staticBackdropLabel">
                    {props.productname}
                  </h2>
                  <button
                    ref={cancel}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={cancelHandler}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Name: {localStorage.getItem("foodapp-name")}</p>
                  <p>Email: {localStorage.getItem("foodapp-email")}</p>
                  <p>
                    Quantity: &nbsp;
                    <AiFillPlusCircle onClick={plusHandler} /> &nbsp;
                    {quantity} &nbsp;
                    {quantity > 1 && (
                      <AiFillMinusCircle onClick={minusHandler} />
                    )}
                  </p>
                  <h5>
                    <span className="badge bg-dark">Price: {itemPrice} </span>
                  </h5>
                  <form onSubmit={submitHandler}>
                    <div className={`${name.isValid ? "" : "invalid"}`}>
                      <label className="form-label">Name* :</label>
                      <input
                        ref={nameFocus}
                        type="text"
                        className="form-control"
                        aria-describedby="emailHelp"
                        value={name.enteredName}
                        onChange={nameChangeHandler}
                        // onBlur={nameValidHandler}
                      />
                    </div>
                    <div className={`${address.isValid ? "" : "invalid"}`}>
                      <label className="form-label">Address* :</label>
                      <textarea
                        ref={addressFocus}
                        className="form-control"
                        id="floatingTextarea"
                        onChange={addressChangeHandler}
                        value={address.enteredAddress}
                      ></textarea>
                      <p>&nbsp;</p>
                      <button type="submit" className="btn btn-primary">
                        Place an Order
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
